<script>
  export default {
    props: {},
    data() {
      return {}
    },
    methods: {},
    computed: {},
    watch: {},
    components: {},
    mounted() {
    },
    destroyed() {
    }
  }
</script>
<template>
  <div class="sidebar">
    <div class="sidebar__menu">
      <a href="http://www.mag.travel/"><span class="sidebar__home"></span>Главная</a>
      <a href="http://www.mag.travel/for_agency/"><span class="sidebar__agency"></span>Агентствам</a>
      <a href="http://www.mag.travel/for_operators/"><span class="sidebar__operators"></span>Туроператорам</a>
      <a href="http://www.mag.travel/rates/"><span class="sidebar__rates"></span>Тарифы</a>
      <a href="http://www.mag.travel/faq/"><span class="sidebar__faq"></span>FAQ</a>
      <a href="http://www.mag.travel/about_company/"><span class="sidebar__company"></span>О компании</a>
      <a href="http://www.mag.travel/about_company/"><span class="sidebar__contact"></span>Контакты</a>
    </div>
    <div class="sidebar__top"></div>
  </div>
</template>